if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('button');
        this.parent = this.closest('.parent-display');

        this.items = this.parent.querySelectorAll('.show-more-item');
        this.labelShowMore = this.button.querySelector('.label-show-more');
        this.labelShowLess = this.button.querySelector('.label-show-less');

        this.button.addEventListener('click', (event) => {
          this.expandShowMore();

          const nextElementToFocus = this.parent.querySelector('.show-more-item:not(.hidden)');
          if (nextElementToFocus?.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });

        // Initial state
        setTimeout(() => {
          this.items.forEach((item) => {
            item.classList.add('hidden');
          });

          this.labelShowMore.classList.remove('hidden');
          this.labelShowLess.classList.add('hidden');
        }, 500);
      }

      expandShowMore() {
        const isExpanded = this.labelShowMore.classList.contains('hidden');

        console.log("isExpanded", isExpanded);

        this.items.forEach((item) => {
          item.classList.toggle('hidden');
        });

        this.labelShowMore.classList.toggle('hidden');
        this.labelShowLess.classList.toggle('hidden');
      }
    }
  );
}

document.querySelectorAll('.collection-search-input').forEach(input => {
  const wrapper = input.closest('.facets__display-vertical');
  const list = wrapper.querySelector('.facets__list--vertical');

  input.addEventListener('focus', () => {
    list.style.display = 'block';
  });

  input.addEventListener('blur', () => {
    setTimeout(() => {
      list.style.display = 'none';
    }, 200); // delay so checkbox click works
  });
});